module.exports = __webpack_public_path__ + "img/thai_gem_jewery_trader_association.69aad1ca.png";